module.exports = __webpack_public_path__ + "static/upgrade2-b4d5aaa4e0f9fbe83060d78de49ce5f8.png";